export const Delivery = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.03707 36.1937L22.5016 44.958C23.0519 45.2723 23.5922 45.4294 24.1225 45.4294C24.6528 45.4294 25.1996 45.2723 25.7631 44.958L41.2088 36.1937C42.1128 35.6697 42.7971 35.0768 43.2616 34.4151C43.7268 33.754 43.9594 32.7226 43.9594 31.3208V15.7577C43.9594 14.736 43.7662 13.8911 43.3799 13.2231C42.9931 12.5546 42.3874 11.978 41.5628 11.4934L27.6488 3.59398C26.4705 2.91284 25.2985 2.57227 24.1328 2.57227C22.9671 2.57227 21.7879 2.91284 20.5954 3.59398L6.70279 11.4934C5.8645 11.9786 5.25193 12.5551 4.86507 13.2231C4.47879 13.8911 4.28564 14.736 4.28564 15.7577V31.3208C4.28564 32.7226 4.52136 33.754 4.99279 34.4151C5.46422 35.0763 6.14564 35.6691 7.03707 36.1937ZM8.80536 33.6C8.22822 33.2726 7.8285 32.9286 7.60622 32.568C7.38336 32.208 7.27193 31.7594 7.27193 31.2223V16.386L22.5805 25.1306V41.4403L8.80536 33.6ZM39.4594 33.6L25.6654 41.4403V25.1306L40.9714 16.386V31.2223C40.9714 31.7594 40.8599 32.208 40.6371 32.568C40.4142 32.928 40.0219 33.2723 39.4602 33.6008M24.1336 22.3808L8.96222 13.7923L15.0342 10.3148L30.2039 18.9411L24.1336 22.3808ZM33.3685 17.154L18.1388 8.54569L21.9119 6.40369C23.4056 5.55227 24.8859 5.55227 26.3528 6.40369L39.3025 13.7923L33.3685 17.154Z"
        fill="#C4B57C"
      />
    </svg>
  );
};
